import { createSlice } from "@reduxjs/toolkit";

export const apiConfigSlice = createSlice({
  name: "api-config",
  initialState: {
    isLoading: false,
    isError: false,
    getApiConfig: [],
    message: "",
  },
  reducers: {
    onGetApiConfig: (state) => {
      return {
        ...state,
        isLoading: true,
        isError: false,
        getApiConfig: [],
        message: "",
      };
    },
    onGetApiConfigSuccess: (state, { payload }) => {
      const { data = [], message = "", status_code = 200 } = payload;
      return {
        ...state,
        isLoading: false,
        getApiConfig: data,
        message,
        status_code,
      };
    },
    onGetApiConfigError: (state, { payload }) => {
      const { data = [], message = "", status_code = 400 } = payload;
      return {
        ...state,
        isLoading: false,
        getApiConfig: data,
        message,
        status_code,
      };
    },
    onGetApiConfigReset: (state) => {
      return {
        ...state,
        isLoading: false,
        getApiConfig: [],
        message: "",
        status_code: null,
      };
    },
  },
});

export const {
  onGetApiConfig,
  onGetApiConfigSuccess,
  onGetApiConfigError,
  onGetApiConfigReset
} = apiConfigSlice.actions;

export default apiConfigSlice.reducer;
